<template>
  <div class="kf-error text-center py-10 px-4">
    <LucideIcon name="circle-alert" :size="52" color="#E57373" />
    <div class="kf-error__title mt-4">{{ title }}</div>
    <div class="kf-error__message mt-1">{{ displayMessage }}</div>
    <v-btn
      v-if="showRetry"
      class="mt-5 text-none"
      color="primary"
      outlined
      small
      @click="$emit('retry')"
    >
      <LucideIcon name="refresh-cw" :size="18" class="mr-1" />
      Try again
    </v-btn>
  </div>
</template>

<script>
export default {
  name: "KfErrorState",
  props: {
    title: { type: String, default: "Could not load this" },
    message: { type: [String, Error, Object], default: "" },
    showRetry: { type: Boolean, default: true },
  },
  computed: {
    displayMessage() {
      const m = this.message;
      if (!m) return "Something went wrong while fetching the data.";
      if (typeof m === "string") return m;
      // Accepts an Error or an axios error object without the caller unwrapping.
      return (
        (m.response && m.response.data && m.response.data.detail) ||
        m.message ||
        "Something went wrong while fetching the data."
      );
    },
  },
};
</script>

<style scoped>
.kf-error__title {
  font-size: 16px;
  font-weight: 600;
  color: #000;
}
.kf-error__message {
  font-size: var(--kf-fs-hint);
  color: #000;
  max-width: 460px;
  margin: 0 auto;
  line-height: 1.5;
}
</style>
